import React from 'react';
import { ICON_SIZE_MAP } from './constants';
export const resolveButtonContent = ({ iconLeft, iconRight, children, }) => {
    const icon = iconLeft || iconRight;
    if (icon && !children) {
        return {
            type: 'OnlyIcon',
            icon: icon,
        };
    }
    return {
        type: 'Regular',
        children,
        iconLeft,
        iconRight,
    };
};
export const adjustIconSize = (iconEl, size) => {
    if (!iconEl) {
        return;
    }
    const iconSize = ICON_SIZE_MAP[size];
    return React.cloneElement(iconEl, { size: iconEl.props.size ?? iconSize });
};
//# sourceMappingURL=button-content.js.map